
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { MobileActionButtons } from './components/feature/MobileActionButtons';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen flex flex-col">
        <main className="flex-1 pb-20 md:pb-0">
          <AppRoutes />
        </main>
        <MobileActionButtons />
      </div>
    </BrowserRouter>
  );
}

export default App;
